import { refundPayment } from 'helpers/API Calls/Operations/booking';
import { useNavigate } from 'react-router-dom';
import ModalWrapper from 'Components/Modals/ModalWrapper';

function RefundPayment({onCloseClick, data}) {
    const navigate = useNavigate();

   const handleConfirm = async (e) => {
       e.preventDefault();
        const form = e.target;
       if (data) {
         const response = await refundPayment(data.id, {amount:  form.refund_amount.value, charge_id: data?.payments?.[0]?.payment_reference});
         if (response.success) {
              onCloseClick();
              navigate('/payments', { state: { booking: response.data } });
         }
       }
    };
  return (
    <ModalWrapper
        show={true}
        onCloseClick={onCloseClick}
        title='Refund Payment'
        body={
            <form onSubmit={handleConfirm} autoComplete="off">
                <div className="mb-3">
                    <label htmlFor="refund_amount" className="form-label">Refund Amount <span className="text-danger">*</span></label>
                    <input
                        type="number"
                        className="form-control"
                        id="refund_amount"
                        name="refund_amount"
                        defaultValue={parseFloat(data?.payments?.[0]?.paid_amount).toFixed(2)}
                        required
                        min={1}
                        max={data?.payments?.[0]?.paid_amount}
                        step="0.01"
                    />
                </div>
                <div className="text-end">
                    <button type="button" className="btn btn-secondary me-2" onClick={onCloseClick}>Cancel</button>
                    <button type="submit" className="btn btn-primary">Refund Payment</button>
                </div>
            </form>
        }
    />
  )
}

export default RefundPayment
